@import '../../../constants/spacing.module.less';

.dropdown-field {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-4;
}
